<template>
     <div class="container" v-title="'业务领域'">
         <Navigation-bar title="业务领域"></Navigation-bar>
        <div class="container_content">
            <div id="Business">
                <div class="tab" v-scrollShadow="roll">
                    <ul>
                        <li v-for="(item,index) in tabs" :key="index"
                            :class="{'active':index == tabIndex}"
                            @click="select(index)"
                        >{{item}}</li>
                    </ul>
                </div>
                <div class="Business_scroll" v-scroll="roll">
                    <div class="Business_content">
                        <div class="tab_content">
                            <ul>
                                <li class="brand_competition" v-show="tabIndex == 0">
                                    <div class="b_subtitle">赛事领域</div>
                                    <p>从2017年起，协会先后升级、创办了足球、篮球、气排球、乒乓球、棋牌、电竞、汽摩、沙滩运动等多项全国性职工单项品牌赛事，作为引领职工体育全面发展的引擎。其中，核心赛事包括但不限于：</p>
                                    <ul>
                                        <li>中国职工足沙滩运动会</li>
                                        <li>中国职工足球联赛</li>
                                        <li>中国职工乒乓球联赛</li>
                                        <li>中国职工汽车拉力系列赛</li>
                                        <li>中国职工气排球锦标赛</li>
                                        <li>中国职工桥牌锦标赛</li>
                                        <li>中国职工网球邀请赛</li>
                                        <li>全国行业职工男子篮球赛</li>
                                        <li>中国职工围棋锦标赛</li>
                                        <li>中国职工电竞大赛</li>
                                        <li>中国职工足球电竞赛</li>
                                    </ul>
                                    <img :src="getImg('品牌赛事_1')" style="margin-top:0.64rem">
                                    <img :src="getImg('品牌赛事_2')" style="margin-top:1rem">
                                    <img :src="getImg('品牌赛事_3')" style="margin-top:0.86rem">
                                    <img :src="getImg('品牌赛事_4')" style="margin-top:0.62rem">
                                    <img :src="getImg('品牌赛事_5')" style="margin-top:0.64rem">
                                </li>
                                <li class="athletic_training"  v-show="tabIndex == 1">
                                    <div class="b_subtitle">培训内容</div>
                                    <p>协会与中国足球协会、中国排球协会等官方机构合作,长期举办各类职工体育培训活动，包括但不限于：</p>
                                    <ul>
                                        <li>·中国足协等级裁判员</li>
                                        <li>·中国足协教练员培训班</li>
                                        <li>·中国排协气排球裁判员</li>
                                        <li>·中国气排球教练员培训班</li>
                                        <li>·中国职工亲子足球课堂</li>
                                    </ul>
                                    <img :src="getImg('体育培训_1')" style="margin-top:0.32rem">
                                    <img :src="getImg('体育培训_2')" style="margin-top:0.25rem">
                                </li>
                                <li v-show="tabIndex == 2">
                                    <p style="margin-bottom:0">2019年，由国家卫健委、国家体育总局、中华全国总工会、国家文化和旅游部指导、中国健康管理协会统筹的“全国职工健康促进工程正式启动”，中国企业体协牵头负责“健康运动”板块。</p>
                                    <p>同时，协会整合各方资源，研发并推出职工运动健康管理一揽子服务，包括体质监测、健康处方干预与应用、365职工健康服务、品牌连锁健身房等。</p>
                                    <img :src="getImg('健康管理')" style="margin-top:0.32rem">
                                </li>
                                <li v-show="tabIndex == 3">
                                    <p>在多年的业务实践中，协会与全国多个省市的体育赛事、培训、运动、康养基地、场馆建立了合作关系，并为其中部分基地授予了 “中国企业体育协会赛事活动基地”资质。在此基础上，协会与上述基地联手开发“职工运动休闲与康养”项目，为各会员单位和全国企事业单位提供职工运动康养服务。</p>
                                    <img :src="getImg('运动康养_1')" style="margin-top:0.32rem">
                                    <img :src="getImg('运动康养_2')" style="margin-top:0.22rem">
                                </li>
                                <li v-show="tabIndex == 4">
                                    <p>为了更好地整合职工赛事资源，加强职工赛事的系统化、规范化、科学化、数据化管理，中企体协开发了一整套完备的职工赛事管理系统，并建立了线上运营平台——亿动APP。该系统包括赛事认证、赛事积分、运动员评级和竞赛管理四大功能，为职工体育赛事赋予官方价值，为参赛队、运动员提供特别荣誉，为赛事组织者提供完善服务。</p>
                                    <img :src="getImg('赛事系统')" style="margin-top:0.56rem">
                                </li>
                                <li v-show="tabIndex == 5">
                                    <p>在上述业务开发过程中，协会注重以职工体育为媒介，促进同业交流与异业合作；以职工体育为载体，面向不同行业的垂直细分人群，进行有机、精准的品牌宣传与产品营销。</p>
                                    <img :src="getImg('整合营销_1')" style="margin-top:0.32rem">
                                    <img :src="getImg('整合营销_2')" style="margin-top:0.24rem">
                                    <img :src="getImg('整合营销_3')" style="margin-top:0.24rem">
                                </li>
                                <li v-show="tabIndex == 6">
                                    <p>助力体育公益事业是协会责任和追求，多年来，协会持续通过各类线上、线下活动为贫困地区孩子们捐赠运动装备和体育器材，救助人数超过万人。</p>
                                    <img :src="getImg('体育公益_1')" style="margin-top:0.40rem">
                                    <img :src="getImg('体育公益_2')" style="margin-top:0.24rem">
                                    <img :src="getImg('体育公益_3')" style="margin-top:0.24rem">
                                </li>
                                <li class="cooperation" v-show="tabIndex == 7">
                                    <ul>
                                        <li v-for="(item,index) in cooperationList" :key="index">
                                            <div class="b_subtitle">{{item.title}}</div>
                                            <div class="info">
                                                <p>{{item.name}}</p>
                                                <p>{{item.phone}}</p>
                                                <p>{{item.E_mail}}</p>
                                            </div>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     </div>
</template>
<script>
import $ from 'jquery';
export default {
    name:"Business",
    data(){
        return{
            roll:0,
            tabs:[
                '品牌赛事',
                '体育培训',
                '健康管理',
                '运动康养',
                '赛事系统',
                '整合营销',
                '体育公益',
                '业务合作'
            ],
            tabIndex:0,
            cooperationList:[
                {
                    title:'中国职工足球联赛',
                    name:'赵 岩',
                    phone:'13501200312',
                    E_mail:'zhaoyan@cesa.org.cn'
                },
                {
                    title:'中国职工乒乓球/羽毛球联赛',
                    name:'南相宇',
                    phone:'18211053310',
                    E_mail:'nanxiangyu@cesa.org.cn'
                },
                {
                    title:'中国职工气排球锦标赛',
                    name:'路 岩',
                    phone:'13811795857',
                    E_mail:'luyan@cesa.org.cn'
                },
                {
                    title:'中国职工桥牌锦标赛/中国职工围棋锦标赛',
                    name:'苏 新',
                    phone:'13910608448',
                    E_mail:'suxin@cesa.org.cn'
                },
                {
                    title:'全国行业企业职工篮球赛',
                    name:'刘大铭',
                    phone:'13641319879',
                    E_mail:'liudaming@cesa.org.cn'
                },
                {
                    title:'中国职工网球精英系列赛/中国职工足球电竞系列赛',
                    name:'刘 雅',
                    phone:'18911722174',
                    E_mail:'liuya@cesa.org.cn'
                },
                {
                    title:'中国职工电子竞技大赛',
                    name:'刘骁骅',
                    phone:'13910056899',
                    E_mail:'liuxiaohua@cesa.org.cn'
                },
                {
                    title:'职工体质监测与运动处方服务',
                    name:'田 超',
                    phone:'13501276713',
                    E_mail:'tianchao@cesa.org.cn'
                },
                {
                    title:'协会官方媒体宣传合作',
                    name:'张旭阳',
                    phone:'18612473792',
                    E_mail:'zhangxuyang@cesa.org.cn'
                },
                {
                    title:'入会申请',
                    name:'白宝林',
                    phone:'17710055345',
                    E_mail:'baibaolin@cesa.org.cn'
                }
            ]
        }
    },
    watch:{
        tabIndex:function(index){
            var left = 0;
            if(index-1 > 0){
                let w1 = $('.tab').outerWidth(),
                    w2 = $('.tab ul').outerWidth();
                $.each($('.tab ul li'),function(i,item){
                    if(i < index-1){
                        left += $(item).outerWidth(true);
                    }
                })
                if(w2 - w1 < left){
                    left = w2 - w1;
                }
            }
            $('.tab').scrollLeft(left);
        }
    },
    methods:{
        select(index){
            this.tabIndex = index;
            this.roll = 0;
        },
        getImg(url){
            return require(`@/assets/images/Association/业务领域/${url}@2x.png`);
        }
    }
}
</script>
<style lang="scss" scoped>
#Business{
    position: relative;
    overflow: hidden;
    .tab{
        width: 100%;
        height: 80px;
        background: #ffffff;
        overflow-x: auto;
        position: relative;
        z-index: 1;
        ul{
            width: max-content;
            height: 100%;
            display: flex;
            white-space: nowrap;
            padding: 0 22px 0 40px;
            li{
                @include line-height(80px);
                font-size: 32px;
                color: #1B1C1E;
                font-weight: 400;
                margin-right: 32px;
                &:last-of-type{
                    margin-right: 0;
                }
                &.active{
                    color: #EC1B24;
                    font-weight: 600;
                    border-bottom: 4px #EC1B24 solid;
                    box-sizing: border-box;
                }
            }
        }
    }
    .Business_scroll{
        height: calc(100% - 80px);
        width: 100%;
        overflow-y: auto;
    }
    .Business_content{
        padding: 0 40px;
        box-sizing: border-box;
        .tab_content{
            width: 100%;
            >ul{
                width: 100%;
                >li{
                    padding: 40px 0;
                    box-sizing: border-box;
                    .b_subtitle{
                        width: 100%;
                        font-size: 32px;
                        color: #1B1C1E;
                        font-weight: 500;
                        line-height: 44px;
                        margin-bottom: 16px;
                    }
                    p{
                        width: 100%;
                        font-size: 28px;
                        color: #575757;
                        line-height: 38px;
                        font-weight: 400;
                        margin-bottom: 24px;
                        letter-spacing: 0;
                    }
                    img{
                        width: 670px;
                    }
                }
                .brand_competition{
                    width: calc(100% + 80px);
                    margin-left: -40px;
                    .b_subtitle,
                    p{
                        padding: 0 40px;
                        box-sizing: border-box;
                    }
                    ul{
                        padding-left: 40px;
                        box-sizing: border-box;
                        li{
                            width: 336px;
                            @include line-height(40px);
                            font-size: 28px;
                            color: #DC484A;
                            font-weight: 500;
                            padding-left: 32px;
                            box-sizing: border-box;
                            @include bg-image('~@images/icon/icon_旗帜');
                            background-repeat: no-repeat;
                            background-size: 24px 24px;
                            background-position: 0 center;
                            display: inline-block;
                            margin-bottom: 16px;
                            &:nth-of-type(2n){
                                width: 370px;
                            }
                        }
                    }
                    img{
                        width: 750px;
                    }
                }
                .athletic_training{
                    p{
                        margin-bottom: 16px;
                    }
                    ul li{
                        width: 320px;
                        font-size: 28px;
                        color: #DC484A;
                        line-height: 46px;
                        font-weight: 500;
                        display: inline-block;
                        &:nth-of-type(2n){
                            width: 340px;
                        }
                    }
                }
                .cooperation{
                    width: calc(100% + 40px);
                    ul li{
                        border-bottom: 1px #e5e5e5 solid;
                        margin-bottom: 23px;
                        &:last-of-type{
                            border: none;
                            margin-bottom: 0;
                        }
                        .b_subtitle{
                            width: 100%;
                            font-size: 32px;
                            color: #1B1C1E;
                            font-weight: 500;
                            line-height: 44px;
                            padding-right: 80px;
                            box-sizing: border-box;
                            margin: 0;
                        }
                        .info{
                            padding: 24px 0;
                            p{
                                width: 100%;
                                font-size: 28px;
                                color: #575757;
                                letter-spacing: 1px;
                                line-height: 38px;
                                font-weight: 400;
                                padding-left: 46px;
                                box-sizing: border-box;
                                background-repeat: no-repeat;
                                background-size: 28px 28px;
                                background-position: 0 center;
                                margin-bottom: 16px;
                                &:nth-of-type(1){
                                    color: #1B1C1E;
                                    letter-spacing: 0;
                                    @include bg-image('~@images/icon/icon_名字');
                                }
                                &:nth-of-type(2){
                                    @include bg-image('~@images/icon/icon_电话');
                                }
                                &:nth-of-type(3){
                                    @include bg-image('~@images/icon/icon_邮箱');
                                    margin-bottom: 0;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>